<script lang="ts">
	import Skeleton from '$lib/shadcn/components/ui/skeleton/skeleton.svelte';
	import { cn } from '$lib/shadcn/utils';
	import type { ClassValue } from 'svelte/elements';

	let {
		class: className
	}: {
		class?: ClassValue | undefined;
	} = $props();
</script>

<Skeleton class={cn('bg-background-3 animate-shimmer h-5.5 w-full', className)}></Skeleton>
